import { PENDING_UPLOADS } from '../constants'
import { PendingUpload } from './addPendingUpload'

export function getPendingUploads(): PendingUpload[] {
  const data = localStorage.getItem(PENDING_UPLOADS)
  return data
    ? JSON.parse(data)
    : []
}
